import moment from 'moment'
import React, { useEffect, useState } from 'react'
import DatePicker, { CalendarContainer, setHours, setMinutes } from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.min.css";
import { getDateViewFromMysql } from 'utils/MyUtils';

const DatetimepickerMy = (props) => {
    const { name, renderFunc, validation, setValue, register, handleSubmit, watch, control, value = "", className, icon, error, label, placeholder, mb = "3", ...rest } = props
    const [mydate, setMyDate] = useState();
    const pholder = placeholder === " " ? label : placeholder



    const MyContainer = ({ className, children }) => {
        return (
            <div style={{ padding: "2px", background: "#007bff", color: "#fff" }}>
                <CalendarContainer className={className}>
                    <div style={{ position: "relative" }}>{children}</div>
                </CalendarContainer>
            </div>
        );
    };

    useEffect(() => {
        if (moment(value).isValid()) {
            const val = moment(value).utc(false).format("YYYY-MM-DD HH:mm")
            const dateval = getDateViewFromMysql(val)
            setValue(name, val)
            setMyDate(dateval)
        } else {
            setValue(name, "")
        }
    }, [value])

    return (
        <div className={`${icon ? "input" : "form"}-group mb-${mb}`}>
            {label && <label>{label}</label>}

            <DatePicker
                {...register(name, { ...validation })}
                showMonthDropdown
                showYearDropdown
                showTimeSelect
                className={`form-control ${error ? "is-invalid" : ""} 
                ${className}`}
                placeholderText={pholder}
                selected={mydate}
                onChange={(date) => {
                    setMyDate(date)
                    if (moment(date).isValid()) {
                        setValue(name, moment(date).utc(true).format("YYYY-MM-DD HH:mm"))
                    } else {
                        setValue(name, "")
                    }
                }}
                //calendarContainer={MyContainer}
                //popperPlacement="top-start"
                {...rest}
            />
            {icon && <div className="input-group-append">
                <div className="input-group-text">
                    <span className={`fas ${icon}`} />
                </div>
            </div>}

            {error && <span className="text-danger">{error}</span>}
        </div>
    )
}

DatetimepickerMy.defaultProps = {
    register: () => { },
    setValue: () => { },
    name: "",
    validation: {},
    className: "",
    error: "",
    label: "",
    placeholder: " ",
    dateFormat: "dd/MM/y HH:mm",
    timeFormat: "HH:mm",
    timeIntervals: 15,
}
export default DatetimepickerMy
